<template>
  <div class="layout">
    <navbar></navbar>
    <div class="layout-bottom">
      <side-menu></side-menu>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import navbar from './components/navbar'
import sideMenu from './components/sideMenu'
import AppMain from './components/AppMain'

export default {
  components: {
    navbar,
    sideMenu,
    AppMain
  },
  props: {},
  data: () => ({}),
  computed: {},
  watch: {},
  methods: {},
  created() {}
};
</script>

<style lang="scss" scoped>
.layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: $bg-normal;
  color: $text-primary;
}
.layout-bottom {
  display: flex;
  flex: 1;
}
</style>
